// extracted by mini-css-extract-plugin
module.exports = {"container":"sectionHeader_container__SXUY8","title":"sectionHeader_title__2ZRVT","secondary":"sectionHeader_secondary__jir2L","third":"sectionHeader_third__RoQzO"};